import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDNENXTXthCXUmloOk-O-HQZMpQWFo54Ak",
  authDomain: "cdm-grid.firebaseapp.com",
  databaseURL: "https://cdm-grid-default-rtdb.firebaseio.com",
  projectId: "cdm-grid",
  storageBucket: "cdm-grid.firebasestorage.app",
  messagingSenderId: "243638786151",
  appId: "1:243638786151:web:1c605636d5cb376be95cc2"
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export const auth = getAuth(app);

// Signs the client in anonymously (no user-visible account or prompt).
// Resolves with the Firebase user, or null if sign-in fails, e.g. the
// Anonymous provider is not enabled in the Firebase console.
export function ensureSignedIn() {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        unsubscribe();
        resolve(user);
      }
    });
    signInAnonymously(auth).catch((error) => {
      // Handled, not fatal: the app falls back to a persistent per-device
      // identity key (utils/identity.js). Enable the Anonymous provider in
      // the Firebase console to switch identities over to auth uids.
      console.warn(
        `Anonymous auth unavailable (${error?.code || 'unknown'}), using a per-device identity key instead.`
      );
      unsubscribe();
      resolve(null);
    });
  });
}
